export class HistoryModel {
    constructor() {
        this.Id = 0;
        this.PatientId = "";
        this.Status = "";
        this.StartDate = "";
        this.EndDate = "";
    }
}